<ng-container *ngIf="data">
    <h3 mat-dialog-title>Users Assigned to {{ data.permission.name }}</h3>
    <mat-dialog-content>
        <kendo-grid
            [loading]="loading"
            [data]="grid"
            [sortable]="sortable"
            [scrollable]="'scrollable'"
            [sort]="sort"
            (sortChange)="sortChange($event)"
            [height]="500"
            class="lg-kendo-grid"
            #kendoGrid="kendoGrid"
            [autoSize]="true"
        >
            <kendo-grid-column field="lfName" title="Name"></kendo-grid-column>
            <kendo-grid-column field="loginEmail" title="Email"></kendo-grid-column>
            <kendo-grid-column field="position" title="Position"></kendo-grid-column>
            <kendo-grid-column field="defaultPermissions" title="Default">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    {{ dataItem.defaultPermissions ? 'Yes' : 'No' }}
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </mat-dialog-content>
</ng-container>
